import React from 'react'

import { NUMBER_OF_HANDS } from '../../mock'

export const NumberOfHands = ({
  selectedFilters,
  rewriteSelectedFiltersAction,
  sendChartOptionSelectToAnalytics
}) => {
  const onPress = (item) => {
    rewriteSelectedFiltersAction({ key: 'chartType', value: item })

    sendChartOptionSelectToAnalytics(item)
  }

  return (
    <div
      style={{
        fontSize: '16px',
        fontFamily: ' Roboto, sans-serif',
        width: '100%',
      }}
      className="ICMCharts__label"
    >
      <p>Number of Hands</p>
      <div className="PreflopCharts__options-row">
        {Object.entries(NUMBER_OF_HANDS).map(([value, label], idx) => {
          const isSelected = value === selectedFilters.chartType
          return (
            <div
              key={value}
              onClick={() => onPress(value)}
              className="ICMCharts__button"
              style={{
                borderWidth: isSelected ? '2px' : 0,
              }}
            >
              <div
                className="ICMCharts__button-label"
                style={{
                  color: isSelected ? '#0085FF' : 'black',
                }}
              >
                {value}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
